<template>
  <v-dialog :value="value" @input="input => $emit('input', input)" width="350">
    <v-card>
      <v-card-title>Testar link</v-card-title>
      <v-card-text class="pt-6 pb-1">
        <v-text-field
          v-model="testCode"
          label="Código de testes do Facebook (API de Conversões)"
          placeholder="Cole aqui"
          outlined
          hide-details
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="pr-5 pl-5 pb-5 pt-6">
        <v-btn color="secondary" depressed light block @click="open()">Abrir link</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['value', 'url'],
  data () {
    return {
      testCode: ''
    }
  },
  methods: {
    open () {
      window.open(`${this.url}?test_event_code=${this.testCode}`)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>